import reactPdfWorkerSrc from 'virtual:react-pdf-worker-url'

let isPdfjsWorkerConfigured = false

/**
 * Configures the react-pdf pdfjs worker URL once before any `getDocument` call.
 * Used by upload validation (`src/utils/file.ts`).
 */
export const configurePdfjsWorker = async () => {
  if (isPdfjsWorkerConfigured) {
    return
  }

  const { pdfjs } = await import('react-pdf')
  pdfjs.GlobalWorkerOptions.workerSrc = reactPdfWorkerSrc
  isPdfjsWorkerConfigured = true
}
